// Точки Zepp для графиков: из общих метрик берутся только записи источника `zepp`.

import { useQuery } from '@tanstack/react-query'

import { metricsApi } from '@/pages/metrics/api'

export const ZEPP_SOURCE = 'zepp'
const LIMIT = 200

export function useZeppSamples(metric: 'weight' | 'body_fat_pct') {
  return useQuery({
    queryKey: ['metrics', 'samples', metric, 'zepp'],
    queryFn: async () => {
      const page = await metricsApi.samples(metric, null, LIMIT)
      if (!Array.isArray(page.items)) return []
      return page.items.filter((s) => s.source === ZEPP_SOURCE)
    },
  })
}
